/**
 * UI elements
 */
class Orion_UI {
  constructor() {
    this.initSmoothScroll();
    this.detectEdge();
    this.changeColorList();
    this.initTextAccordion();
  }

  initSmoothScroll () {
    $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - 110
          }, 1000);
        }
      }
    });
  }

  detectEdge () {
    if (document.documentMode || /Edge/.test(navigator.userAgent)) {
      document.body.classList.add('browser--is-edge')
    }
  }

  changeColorList () {
    let colorList = $('.color-list-item');
  
    if (!colorList.length) {
      return
    }

    for (let i = 0; i < colorList.length; i++) {
      let colorListDataColor = colorList.eq(i).attr('data-color');
      colorList.eq(i).find('.color-list li .color-dot').css('background', colorListDataColor);
    }
  }

  initTextAccordion () {
    if ($(document.body).hasClass('js-ui-accordion-initialized')) {
      return;
    }

    $(document.body).addClass('js-ui-accordion-initialized');

    $(".js-accordion").each(function(i, item) {
      $(item).find('.js-accordion-content').css('height', 0);

      $(item).on("click", function () {
        let item = $(this);
        let contentWrapper = item.find('.js-accordion-content');
        let contentText = item.find('.js-accordion-content > div');
        let contentTitle = item.find('.js-accordion-title > p');
        let contentTitleText = item.find('.js-accordion-title > p > .text');

        item.toggleClass('active');
        let newHeight = contentText.outerHeight();

        if (item.hasClass('active')) {
          contentWrapper.css('height', 0);

          setTimeout(function() {
            contentWrapper.css('height', newHeight + 'px');
          }, 0);

          setTimeout(function() {
            contentWrapper.css('height', 'auto');
          }, 500);

          if(item.hasClass('block-accordion__item--file')) {
            contentTitleText.text(contentTitle.attr('data-text-less'));
          }
        } else {
          contentWrapper.css('height', newHeight + 'px');

          setTimeout(function() {
            contentWrapper.css('height', 0);
          }, 0);

          if(item.hasClass('block-accordion__item--file')) {
            contentTitleText.text(contentTitle.attr('data-text-more'));
          }
        }
      });
    });
  }
}
